import { render, staticRenderFns } from "./entityDialogDisDataRole.vue?vue&type=template&id=4cfea713&scoped=true&"
import script from "./entityDialogDisDataRole.vue?vue&type=script&lang=js&"
export * from "./entityDialogDisDataRole.vue?vue&type=script&lang=js&"
import style0 from "./entityDialogDisDataRole.vue?vue&type=style&index=0&id=4cfea713&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cfea713",
  null
  
)

export default component.exports